<template>
  <div class="page-wrapper msg-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
      <div class="page-title text-upper-case">
        <h1>Active Members (65 or Older) - L713 Medical Plan</h1>
      </div>
      <pending-search
        @onSearch="searchData"
        @onClear="clearData"
        :isL713="true"
        @onExport="handleExport"
      />
      <div class="table-card">
        <div class=" align-items-center top-pagination">
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
        <simple-table :columns="columns">
          <template v-slot:tableBody>
            <pending-table
              :rows.sync="rows"
              :colSpan="columns.length"
              type="L713ActiveMember65"
            />
          </template>
        </simple-table>
        <div class=" align-items-center">
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import PendingTable from "./partials/ActiveMemeberL713Table.vue";
import SimpleTable from "@/components/ui/SimpleTable.vue";
import PendingSearch from "./partials/PendingSearch.vue";
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue";
export default {
  components: {
    SimpleTable,
    PendingTable,
    PendingItemsInternal,
    PendingSearch,
  },
  name: "l713ActiveMembers",
  data: () => ({
    rows: [],
    columns: [
      { label: "Member ID" },
      { label: "Member" },
      { label: "DOB (Member)" },
      { label: "Spouse Name" },
      { label: "DOB (Spouse)" },
      // { label: "Termination Date" },
      { label: "Rep" },
      { label: "Employer/ Group" },
      { label: "Plan(s)" },
    ],
    filters: { search: "" },
    breadcrumbItems: [{ title: "L713ActiveMember65", active: true }],
  }),
  methods: {
    clearData() {
      this.filters.search = "";
      this.getAll(this.filters);
    },
    searchData(query) {
      this.filters.search = query;
      this.getAll(this.filters);
    },
    getAll(filters = null) {
      let url;
      let loader = this.$loading.show();
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/active-members-l713-65?${filterUrl}`;
      } else {
        url = `v2/active-members-l713-65`;
      }
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
    handleExport() {
  const loader = this.$loading.show();
  const exportParam = "export=1";
  let url;

  if (this.filters && Object.keys(this.filters).length > 0) {
    const filterUrl = Helper.objToUrlParams(this.filters);
    url = `v2/active-members-l713-65?${filterUrl}&${exportParam}`;
  } else {
  url = `v2/active-members-l713-65?${exportParam}`;
  }

  Api.get(url)
    .then((res) => {
      if (res.data?.status === "success" && res.data?.file_url) {
          window.open(res.data.file_url);
        // window.open(res.data.file_url, "_blank");
      } else {
        this.$notify("No data found or export failed.", "error");
      }
    })
    .catch((err) => {
      console.error("Export error:", err);
      this.$notify("Failed to export file.", "error");
    })
    .finally(() => {
      loader.hide();
    });
}

  },
  created() {
    this.getAll(this.filters);
  },
};
</script>
<style src="@/assets/css/pending-details.css"></style>
